import { useAppSelector } from "../../../../redux/hooks";
import { CooperativeBankAccount } from "./cooperative";
import { MemberBankAccount } from "./member";

export const BankAccount = () => {
  const { profile } = useAppSelector((state) => {
    return state?.auth;
  });

  return profile?.type === "cooperative" ? (
    <CooperativeBankAccount />
  ) : (
    <MemberBankAccount />
  );
};
